import React from 'react';
import './style.scss';
import AddHeader from '../../../../components/layout/header/add';
import useAddClient from './hooks';
import CommissionType from '../utils/commission-type';
import { DollarSign, Percentage } from '../../../../components/atoms/icons';
import Form from '../../../../components/molecules/forms';
import ClientsAddContact from '../detail/contact';
import ClientsAddPartner from '../detail/partner';
import Button from '../../../../components/molecules/buttons';

function AddClient() {
  const {
    clientId, currentMode, setCurrentMode, addClientFormik, onNavigateCancel,
    clientStateLoading, stateList, businessList, businessLoading, addClientLoad,
    clientById, clientByIdLoad, updateClientLoad,
  } = useAddClient();
  return (
    <div>
      {!clientId && (
      <AddHeader
        primary={{ route: '/clients', title: 'Clients' }}
        title="Add New Client"
      />
      )}
      <form onSubmit={addClientFormik.handleSubmit}>
        <div className="px-4 px-xl-5">
          <div className="fw-bold fz-14 mb-4" style={{ marginLeft: '20px' }}>
            {clientId ? 'Edit Client' : 'Add New Client'}
          </div>
          <div className="row">
            <div className="col-lg-4">
              <Form.Default
                id="name"
                placeholder="Enter Business Name"
                label="Business Name"
                className="mb-4"
                value={addClientFormik.values.name}
                onChange={addClientFormik.handleChange}
                isInvalid={!!addClientFormik.errors.name && addClientFormik.touched.name}
                errorMsg={addClientFormik.errors.name}
                onBlur={addClientFormik.handleBlur}
              />
            </div>
            <div className="col-lg-4">
              <Form.Default
                id="streetAddress"
                placeholder="Enter Street Address"
                label="Street Address"
                className="mb-4"
                value={addClientFormik.values.streetAddress}
                onChange={addClientFormik.handleChange}
                isInvalid={!!addClientFormik.errors.streetAddress && addClientFormik.touched.streetAddress}
                errorMsg={addClientFormik.errors.streetAddress}
                onBlur={addClientFormik.handleBlur}
              />
            </div>
            <div className="col-lg-4">
              <Form.Default
                id="city"
                placeholder="Enter City"
                label="City"
                className="mb-4"
                value={addClientFormik.values.city}
                onChange={addClientFormik.handleChange}
                isInvalid={!!addClientFormik.errors.city && addClientFormik.touched.city}
                errorMsg={addClientFormik.errors.city}
                onBlur={addClientFormik.handleBlur}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <Form.ReactSelect.Default
                id="state"
                placeholder="Enter State"
                label="State"
                className="mb-4"
                value={stateList?.find((state) => addClientFormik.values?.state === state?.value)}
                onChange={(e) => {
                  if (e) addClientFormik.setFieldValue('state', e.value);
                }}
                isInvalid={!!addClientFormik.errors.state && addClientFormik.touched.state}
                errorMsg={addClientFormik.errors.state}
                onBlur={addClientFormik.handleBlur}
                options={stateList}
                disabled={clientStateLoading}
              />
            </div>
            <div className="col-lg-4">
              <Form.Default
                id="zipCode"
                placeholder="Enter Zip Code"
                label="Zip Code"
                className="mb-4"
                value={addClientFormik.values.zipCode}
                onChange={addClientFormik.handleChange}
                isInvalid={!!addClientFormik.errors.zipCode && addClientFormik.touched.zipCode}
                errorMsg={addClientFormik.errors.zipCode}
                onBlur={addClientFormik.handleBlur}
              />
            </div>
            <div className="col-lg-4">
              <Form.ReactSelect.Default
                id="categoryId"
                placeholder="Select Category"
                label="Business Category"
                className="mb-4"
                value={businessList.find((category) => addClientFormik.values.categoryId.toString() === category.value.toString())}
                onChange={(e) => {
                  if (e) addClientFormik.setFieldValue('categoryId', e.value);
                }}
                isInvalid={!!addClientFormik.errors.categoryId && addClientFormik.touched.categoryId}
                errorMsg={addClientFormik.errors.categoryId}
                onBlur={addClientFormik.handleBlur}
                options={businessList}
                disabled={businessLoading}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <CommissionType currentMode={currentMode} setCurrentMode={setCurrentMode} />
            </div>
            <div className="col-lg-4">
              <Form.DefaultWithIcon
                id="commision"
                placeholder="Enter commision"
                className="mb-4"
                label="Enter Commision"
                type="number"
                rightIcon={currentMode === 1 ? <Percentage width={23} /> : <DollarSign width={23} />}
                value={addClientFormik.values.commision}
                onChange={addClientFormik.handleChange}
                isInvalid={!!addClientFormik.errors.commision && addClientFormik.touched.commision}
                errorMsg={addClientFormik.errors.commision}
                onBlur={addClientFormik.handleBlur}
              />
            </div>
          </div>
        </div>
        <div className={!clientId ? '' : 'd-none'}>
          <div className="w-100 bg-stroke mt-4 mb-4" style={{ height: '7px' }} />
          <ClientsAddContact formikClient={addClientFormik} index={0} />
        </div>
        <div className={!clientId ? '' : 'd-none'}>
          <div className="w-100 bg-stroke mt-4 mb-4" style={{ height: '7px' }} />
          <ClientsAddPartner formikClient={addClientFormik} />
        </div>
        <div className="d-flex justify-content-end align-self-end my-4 px-4 px-xl-5">
          <div style={!clientId ? { width: '200px', marginRight: '20px' } : { display: 'none' }}>
            <Button.Default
              id="cancel"
              type="button"
              label="Cancel"
              size="lg"
              outline
              onClick={onNavigateCancel}
            />
          </div>
          <div style={{ width: '200px' }}>
            <Button.Default
              id="save"
              type="submit"
              label="Save Changes"
              size="lg"
              loading={addClientLoad || clientByIdLoad || updateClientLoad}
            />
          </div>
        </div>
      </form>
      <div className={clientById ? '' : 'd-none'}>
        <div className="w-100 bg-stroke mt-4 mb-4" style={{ height: '7px' }} />
        {clientById && clientById.contactPerson.length && clientById.contactPerson.map((contact, index) => (
          <div key={contact.id}>
            <ClientsAddContact clientContactId={contact.id} index={index} />
            <div className="w-100 bg-stroke mt-4 mb-4" style={index === (clientById.contactPerson.length - 1) ? { display: 'none' } : { height: '1px' }} />
          </div>
        ))}
      </div>
      <div className={clientById ? '' : 'd-none'}>
        <div className="w-100 bg-stroke mt-4 mb-4" style={{ height: '7px' }} />
        <ClientsAddPartner clientPartnerId={clientById && clientById.partner ? clientById.partner.id : null} />
        <div className="w-100 bg-stroke mt-4" style={{ height: '7px' }} />
      </div>
      <div className={!clientId ? 'd-none' : 'd-flex justify-content-end align-self-end my-5 px-4 px-xl-5'}>
        <div style={{ width: '200px' }}>
          <Button.Default
            id="cancel"
            type="button"
            label="Cancel"
            size="lg"
            outline
            onClick={onNavigateCancel}
          />
        </div>
      </div>
    </div>
  );
}

export default AddClient;
